module.exports = __webpack_public_path__ + "img/centennial - testimonial video - poster 5.35ca8eb7.jpg";